module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/massage-desktop@2x-77f7efc15d1da67d7ea11d189edcd4dd.jpg";